"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// All translations related to opening hours
var OpeningHours = {
  add_oh: {
    nl: 'Voeg een nieuwe tijdtabel toe',
    fr: "Ajouter un nouvel horaire",
    en: 'Add a new timetable',
    de: 'Fügen Sie einen neuen Zeitplan hinzu'
  },
  no_oh_add: {
    nl: 'Momenteel hebben we nog geen openingsuren ontvangen voor jouw onderneming.',
    fr: "Actuellement, nous n'avons pas encore reçu les heures d'ouverture de votre entreprise.",
    en: 'Currently, we have not yet received any opening hours for your company.',
    de: 'Derzeit haben wir noch keine Öffnungszeiten für Ihr Unternehmen erhalten.'
  },
  open247: {
    nl: 'Open 24/7',
    fr: 'Ouvert 24/7',
    en: 'Open 24/7',
    de: '24/7 geöffnet'
  },
  openClosed: {
    nl: 'Open / Gesloten',
    fr: 'Ouvert / Fermer',
    en: 'Open / Closed',
    de: 'Geöffnet / Geschlossen'
  },
  closed: {
    nl: 'Gesloten',
    fr: 'Fermé',
    en: 'Closed',
    de: 'Geschlossen'
  },
  holidays: {
    nl: 'Feestdagen',
    fr: 'Jours fériés',
    en: 'Holidays',
    de: 'Feiertage'
  },
  showroom: {
    nl: 'Toonzaal',
    fr: "Salle d'exposition",
    en: 'Showroom',
    de: 'Showroom'
  },
  shop: {
    nl: 'Winkel',
    fr: 'Magasin',
    en: 'Shop',
    de: 'Laden'
  },
  office: {
    nl: 'Kantoor',
    fr: 'Bureau',
    en: 'Office',
    de: 'Büro'
  },
  deskoffice: {
    nl: 'Bureau',
    fr: 'Bureau',
    en: 'Desk office',
    de: 'Schreibtischbüro'
  },
  workspace: {
    nl: 'Werkplaats',
    fr: 'Espace de travail',
    en: 'Workspace',
    de: 'Arbeitsplatz'
  },
  vacation: {
    nl: 'Vakantiedagen',
    fr: 'Vacances',
    en: 'Vacation',
    de: 'Urlaub'
  },
  appointment: {
    nl: 'Op afspraak',
    fr: 'Rendez-vous',
    en: 'Appointment',
    de: 'Termin'
  },
  selfservice: {
    nl: 'Self-service',
    fr: 'Self-service',
    en: 'Self-service',
    de: 'Selbstbedienung'
  },
  open247message: {
    nl: 'Wij zijn 24/7 open',
    fr: 'Nous sommes ouverts 24/7',
    en: 'We are open 24/7',
    de: 'Wir sind 24/7 geöffnet'
  },
  monday: {
    nl: 'maandag',
    fr: 'lundi',
    en: 'Monday',
    de: 'Montag'
  },
  tuesday: {
    nl: 'dinsdag',
    fr: 'mardi',
    en: 'Tuesday',
    de: 'Dienstag'
  },
  wednesday: {
    nl: 'woensdag',
    fr: 'mercredi',
    en: 'Wednesday',
    de: 'Mittwoch'
  },
  thursday: {
    nl: 'donderdag',
    fr: 'jeudi',
    en: 'Thursday',
    de: 'Donnerstag'
  },
  friday: {
    nl: 'vrijdag',
    fr: 'vendredi',
    en: 'Friday',
    de: 'Freitag'
  },
  saturday: {
    nl: 'zaterdag',
    fr: 'samedi',
    en: 'Saturday',
    de: 'Samstag'
  },
  sunday: {
    nl: 'zondag',
    fr: 'dimanche',
    en: 'Sunday',
    de: 'Sonntag'
  },
  easter: {
    nl: 'Pasen',
    fr: 'Pâques',
    en: 'Easter',
    de: 'Ostern'
  },
  easterMonday: {
    nl: 'Paasmaandag',
    fr: 'Lundi de Pâques',
    en: 'Easter Monday',
    de: 'Ostermontag'
  },
  laborday: {
    nl: 'Dag van de Arbeid',
    fr: 'Fête du travail',
    en: 'Labor Day',
    de: 'Tag der Arbeit'
  },
  ascensionDay: {
    nl: 'Hemelvaartsdag',
    fr: "Jour de l'ascension",
    en: 'Ascension Day',
    de: 'Christi Himmelfahrt'
  },
  pentecost: {
    nl: 'Pinksteren',
    fr: 'Pentecôte',
    en: 'Pentecost',
    de: 'Pfingsten'
  },
  whitsunMonday: {
    nl: 'Pinksteren maandag',
    fr: 'Lundi de Pentecôte',
    en: 'Whitsun Monday',
    de: 'Pfingstmontag'
  },
  DayOfTheFlemishCommunity: {
    nl: 'Feest van de Vlaamse Gemeenschap',
    fr: 'Jour férié de la communauté Flamande',
    en: 'Day Of The Flemish Community',
    de: 'Tag der Flämischen Gemeinschaft'
  },
  belgianNationalDay: {
    nl: 'Nationale Feestdag',
    fr: 'Fête nationale',
    en: 'Belgian National Day',
    de: 'Nationalfeiertag'
  },
  assumptionOfMary: {
    nl: 'OLV Hemelvaart',
    fr: 'Assomption',
    en: 'Assumption of Mary',
    de: 'Mariä Himmelfahrt'
  },
  dayOfTheWalloonRegion: {
    nl: 'Feest van het Waalse Gewest',
    fr: 'Fête de la Région wallonne',
    en: 'Day of the Walloon Region',
    de: 'Tag der Wallonischen Region'
  },
  halloween: {
    nl: 'Halloween',
    fr: 'Halloween',
    en: 'Halloween',
    de: 'Halloween'
  },
  allSoulsDay: {
    nl: 'Allerzielen',
    fr: 'Toussaint',
    en: "All Souls' Day",
    de: 'Allerheiligen'
  },
  armistice: {
    nl: 'Wapenstilstand',
    fr: 'Armistice',
    en: 'Armistice',
    de: 'Waffenstillstand'
  },
  kingsFeast: {
    nl: 'Koningsdag',
    fr: 'Fête du Roi',
    en: "King's Feast",
    de: 'Königstag'
  },
  dayGermanSpeakingCommunity: {
    nl: 'Dag van de Duitstalige Gemeenschap',
    fr: 'Fête de la Communauté Germanophone',
    en: 'Day of the German-speaking Community',
    de: 'Tag der Deutschsprachigen Gemeinschaft'
  },
  christmasEve: {
    nl: 'Kerstavond',
    fr: 'Réveillon de Noël',
    en: 'Christmas Eve',
    de: 'Heiligabend'
  },
  christmasDay: {
    nl: 'Kerstdag',
    fr: 'Le jour de Noël',
    en: 'Christmas Day',
    de: 'Erster Weihnachtstag'
  },
  newYearsEve: {
    nl: 'Oudjaarsavond',
    fr: 'Réveillon de Nouvel An',
    en: "New Year's Eve",
    de: 'Silvester'
  },
  newYearsDay: {
    nl: 'Nieuwjaarsdag',
    fr: "Le jour de Nouvel An",
    en: "New Year's Day",
    de: 'Neujahrstag'
  },
  jan: {
    nl: 'Jan',
    fr: "Jan",
    en: "Jan",
    de: "Jan"
  },
  feb: {
    nl: 'Feb',
    fr: "Fév",
    en: "Feb",
    de: "Feb"
  },
  mar: {
    nl: 'Mrt',
    fr: "Mars",
    en: "Mar",
    de: "Mär"
  },
  apr: {
    nl: 'Apr',
    fr: "Avr",
    en: "Apr",
    de: "Apr"
  },
  may: {
    nl: 'Mei',
    fr: "Mai",
    en: "May",
    de: "Mai"
  },
  jun: {
    nl: 'Jun',
    fr: "Juin",
    en: "Jun",
    de: "Jun"
  },
  jul: {
    nl: 'Jul',
    fr: "Juil",
    en: "Jul",
    de: "Jul"
  },
  aug: {
    nl: 'Aug',
    fr: "Août",
    en: "Aug",
    de: "Aug"
  },
  sep: {
    nl: 'Sept',
    fr: "Sept",
    en: "Sep",
    de: "Sep"
  },
  oct: {
    nl: 'Okt',
    fr: "Oct",
    en: "Oct",
    de: "Okt"
  },
  nov: {
    nl: 'Nov',
    fr: "Nov",
    en: "Nov",
    de: "Nov"
  },
  dec: {
    nl: 'Dec',
    fr: "Dec",
    en: "Dec",
    de: "Dez"
  },
  oh_info: {
    nl: 'Selecteer een tijdsblok voor meer info',
    fr: "Sélectionnez un bloc de temps pour plus d'informations",
    en: "Select a timeblock for more info",
    de: 'Wählen Sie ein Zeitfenster für weitere Informationen aus'
  },
  openinghours: {
    nl: 'Openingsuren',
    fr: "Heures d'ouverture",
    en: "Openinghours",
    de: 'Öffnungszeiten'
  }
};
var _default = OpeningHours;
exports["default"] = _default;